var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 640 640",
    width: 640,
    height: 640,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M527.81 26.7C617.24 129.74 609.95 272.63 505.94 455.37C401.93 638.11 277.51 679.42 132.68 579.3L527.81 26.7Z",
    id: "c4dKk6G5Po"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.56 115.6C529.27 254.12 268.28 781.93 103.52 522.4C-6.32 349.38 88.94 189.48 389.3 42.7C492.33 -1.04 541.42 23.26 536.56 115.6Z",
    id: "e2vvlC9dbZ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.95 375.38C310.38 421.64 257.54 441.47 218.02 419.63C178.5 397.79 167.17 342.5 192.74 296.24C218.3 249.98 271.14 230.15 310.66 251.99C350.18 273.83 361.51 329.12 335.95 375.38Z",
    id: "arRoUEQZx"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c4dKk6G5Po",
    opacity: 1,
    fill: "#2C8357",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c4dKk6G5Po",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#02c39a",
    strokeWidth: 0,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e2vvlC9dbZ",
    opacity: 1,
    fill: "#f9eab0",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e2vvlC9dbZ",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#44BC7F",
    strokeWidth: 32,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#arRoUEQZx",
    opacity: 1,
    fill: "#7f6e5d",
    fillOpacity: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c2dcc91f3b48bfd9e76f067ee99c6d23.svg";
export { ForwardRef as ReactComponent };